import { Fragment, memo, useMemo } from 'react';
import { NumberRating } from 'foundations-components/transitional/components/NumberRating';
import { Flex } from 'foundations-components/components/Flex';
// @ts-ignore - no TypeScript definitions available
import { makeSafeInnerHTML } from 'feedback-utils/sanitize';
// @ts-ignore - no TypeScript definitions available
import FeedbackNpsBoxRatings from 'feedback-shared-ui/ratings/internal/FeedbackNpsBoxRatings';
import { useWindowSize } from 'forms-utils-lib/hooks/useWindowSize';

// Fallback functions with basic implementations
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getIsNpsRatings = name => {
  var _name$includes;
  return (_name$includes = name === null || name === void 0 ? void 0 : name.includes('nps')) !== null && _name$includes !== void 0 ? _name$includes : false;
};
const getMaxButtonsPerRow = ({
  buttons
}) => Math.min(buttons, 11);
const getIsDeviceMobileOrTablet = device => device === 'MOBILE' || device === 'TABLET';
const getIsTabletOrMobileSize = deviceSize => {
  if (typeof deviceSize === 'object' && deviceSize !== null && 'width' in deviceSize) {
    const size = deviceSize;
    return (size.width || 0) < 768;
  }
  return false;
};
const FeedbackNumberRating = /*#__PURE__*/memo(({
  device,
  highRangeLabel,
  lowRangeLabel,
  max,
  min,
  name,
  onChange,
  isWebSurvey = false,
  value,
  'data-selenium-test': dataSeleniumTest,
  required
}) => {
  const buttons = max - min + 1;
  const deviceSize = useWindowSize();
  const isNpsRatings = useMemo(() => getIsNpsRatings(name), [name]);
  const maxButtonsPerRow = useMemo(() => getMaxButtonsPerRow({
    buttons
  }), [buttons]);
  const showNpsDroppdown = useMemo(() => isNpsRatings && !isWebSurvey && (getIsDeviceMobileOrTablet(device) || getIsTabletOrMobileSize(deviceSize)), [device, isNpsRatings, isWebSurvey, deviceSize]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [!showNpsDroppdown && /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(NumberRating, {
        "data-selenium-test": dataSeleniumTest,
        max: max,
        maxPerRow: maxButtonsPerRow,
        min: min,
        name: name,
        onChange: event => {
          if (onChange) onChange(event.target.value);
        },
        value: typeof value === 'string' ? parseInt(value, 10) || 0 : value || 0,
        required: required,
        highRangeLabel: "",
        lowRangeLabel: ""
      }), (lowRangeLabel || highRangeLabel) && /*#__PURE__*/_jsxs(Flex, {
        justifyContent: "space-between",
        marginBlockStart: "-600",
        inlineSize: "100%",
        children: [lowRangeLabel && /*#__PURE__*/_jsx("span", {
          dangerouslySetInnerHTML: makeSafeInnerHTML(lowRangeLabel)
        }), highRangeLabel && /*#__PURE__*/_jsx("span", {
          dangerouslySetInnerHTML: makeSafeInnerHTML(highRangeLabel)
        })]
      })]
    }), showNpsDroppdown && /*#__PURE__*/_jsx(FeedbackNpsBoxRatings, {
      onRatingChange: onChange,
      selectedRating: value,
      lowRangeLabel: lowRangeLabel,
      highRangeLabel: highRangeLabel
    })]
  });
});
FeedbackNumberRating.displayName = 'FeedbackNumberRating';
export default FeedbackNumberRating;